export const STORAGE_KEYS = {
  tld: "tld",
  default_tld: "default_tld",
  selected_primary_org: "selectedPrimaryOrg",
  accepted_data_privacy_notice: "accepted_data_privacy_notice",
  sidebar_visible: "sidebar_visible",
};
